import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertSupplierConfirmationSlice = createApi(`GetAlertSupplierConfirmationSlice`,"GET");

const GetAlertSupplierConfirmationSlice = createSlice({
  name: 'GetAlertSupplierConfirmationSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertSupplierConfirmationSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertSupplierConfirmationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertSupplierConfirmationSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertSupplierConfirmationSlice.reducer;